import { BrowserRouter } from "react-router-dom";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { useState, useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import SnackBar from "./layouts/snackbar/SnackBar";
import BlockingSnackBar from "./layouts/snackbar/BlockingSnackBar";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <SnackBar />
        <BlockingSnackBar />
        <AppRoutes
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
        />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
